import { render, staticRenderFns } from "./WhatsAppCard.vue?vue&type=template&id=be87796a&scoped=true&"
import script from "./WhatsAppCard.vue?vue&type=script&lang=js&"
export * from "./WhatsAppCard.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppCard.vue?vue&type=style&index=0&id=be87796a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be87796a",
  null
  
)

export default component.exports